document.addEventListener("DOMContentLoaded", function () {
  const words = document.querySelectorAll('.words-animation');
  const icons = document.querySelectorAll('.icon-category');
  if (!words.length && !icons.length) return;

  gsap.registerPlugin(ScrollTrigger);

  words.forEach((el) => {
    gsap.fromTo(el,
      { opacity: 0 },
      {
        opacity: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          start: 'top 90%',
          end: 'top 50%',
          scrub: true,
        },
      }
    );
  });

  icons.forEach((el, i) => {
    gsap.to(el, {
      rotation: i % 2 === 0 ? 15 : -15,
      duration: 2,
      ease: 'sine.inOut',
      yoyo: true,
      repeat: -1,
    });
  });
});
